<template>
    <div class="modal fade" id="complaint_modal" tabindex="-1" role="dialog" aria-labelledby="complaintModal">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    <h4 class="modal-title" id="myModalLabel">New Complaint - Order #: {{orderId}}</h4>
                </div>
                <form class="form-horizontal" @submit.prevent="submitComplaint()">
                    <div class="modal-body">
                        <div class="form-group">
                            <label>Select Nature</label>
                            <select v-model="selectedNature" class="form-control" required="required">
                                <option v-for="(nature, index) in natures" v-bind:value="nature.id" v-bind:key="'nature_'+index">{{nature.nature}}</option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label for="complaint">Complaint</label>
                            <textarea rows="5" required="required" v-model="complaintText" class="form-control" id="complaint" placeholder="Complaint Text Goes Here..."></textarea>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
                        <button type="submit" v-bind:disabled="saveButtonDisable" v-bind:class="'btn btn-primary ld-over ld-ext-right ' + submitBtlLoaderClass">Submit Complaint<i class="ld ld-ring ld-spin"></i></button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
    /* eslint-disable */
    export default {
        name: "OrderComplaint",
        data: function (){
          return {
              complaintText: "",
              selectedNature: "",
              submitBtlLoaderClass: "",
              saveButtonDisable: false,
              natures: []
          }
        },
        created: function () {
          this.$http.get(this.$store.state.mainAppURL +  "complaints/get_all_natures").then(resp => {
             this.natures = resp.data;
          });
        },
        props: {
            orderId: Number
        },
        methods: {
            submitComplaint: function () {
                let complaintObj = {
                    complaint: this.complaintText,
                    complaintsNature: {
                        id:this.selectedNature
                    },
                    orders: {
                        id: this.orderId
                    }
                };
                this.saveButtonDisable = true;
                this.submitBtlLoaderClass = "running";
                this.$http.post(this.$store.state.mainAppURL + "complaints/register_order_complaint", complaintObj).then(resp => {
                   if(resp.data === true){
                       Swal.fire({
                           title: 'SUCCESS!',
                           text: "Complaint has been saved!",
                           type: 'success',
                           showCancelButton: false,
                           confirmButtonColor: '#1ab394',
                           confirmButtonText: 'OK!'
                       }).then(() => {
                           this.complaintText = "";
                           this.selectedNature = -1;
                           this.saveButtonDisable = false;
                           this.submitBtlLoaderClass = "";
                           $("#complaint_modal").modal("hide");
                       });
                   }
                });
            }
        }

    }
</script>

<style scoped>

</style>
